import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
const COMMERCIAL_FAQS = [{
  question: 'Do you offer commercial glass repair near me?',
  answer: 'Kosin&rsquo;s Glass serves commercial glass clients throughout Howell, Ann Arbor, Novi and Southeast Michigan. Request a commercial estimate and the team will confirm availability for your building, project type and location.'
}, {
  question: 'Do you replace storefront glass?',
  answer: 'Yes. Kosin&rsquo;s Glass provides storefront glass repair, storefront glass replacement, commercial entrances, sidelights, commercial door glass and complete storefront systems.'
}, {
  question: 'Do you install office glass walls?',
  answer: 'Yes. Kosin&rsquo;s Glass installs office glass walls, dividers, interior partitions, conference room glass, half walls and other interior commercial glass systems.'
}, {
  question: 'What is contract glazing?',
  answer: 'Contract glazing is commercial glass work for construction, renovation and building projects. It can include storefront systems, curtain walls, commercial windows, doors, entrances, interior glass walls, hardware, fabrication and installation.'
}, {
  question: 'Can you work with builders and general contractors?',
  answer: 'Yes. Kosin&rsquo;s Glass works with builders, contractors, property managers and building owners on commercial glass repair, replacement, fabrication, installation and contract glazing projects.'
}, {
  question: 'Can you repair commercial glass doors?',
  answer: 'Yes. Kosin&rsquo;s Glass can help with commercial door glass replacement, entry door glass, sidelights, and commercial door parts repair or replacement.'
}, {
  question: 'Do you service existing commercial buildings?',
  answer: 'Yes. Kosin&rsquo;s Glass provides repair, replacement, system maintenance and glass service for existing storefronts, office buildings, retail spaces and other commercial properties.'
}, {
  question: 'Do you handle projects outside Southeast Michigan?',
  answer: 'Kosin&rsquo;s Glass primarily serves Southeast Michigan and Michigan. Select larger commercial glazing projects may be available outside Michigan depending on scope, schedule and project requirements.'
}, {
  question: 'What do you need for a commercial glass quote?',
  answer: 'Helpful details include your company name, project address, photos, rough dimensions, drawings or plans, glass type, desired timeline and any bid requirements. Kosin&rsquo;s Glass will confirm exact needs when they contact you.'
}];
export function CommercialGlassFAQ() {
  const [openIdx, setOpenIdx] = useState<number | null>(0);
  return <section className="py-20 bg-white border-t border-slate-200" data-id="element-406" data-mp="1xfq9rhng6406">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-407" data-mp="1jitnzum6rcq5">
        <div className="text-center mb-12 anim-on-scroll" data-id="element-408" data-mp="1ohwk2pk6u8lz">
          <h2 className="kosins-heading text-4xl md:text-5xl text-neutral-900" data-id="element-409" data-mp="1ojhemf6i5rju">
            Commercial Glass Questions
          </h2>
        </div>
        <div className="anim-on-scroll space-y-4" data-id="element-410" data-mp="zxbc63odvel6">
          {COMMERCIAL_FAQS.map((item, idx) => {
          const isOpen = openIdx === idx;
          const panelId = `commercial-faq-panel-${idx}`;
          const buttonId = `commercial-faq-button-${idx}`;
          return <div key={idx} className={`border rounded-lg transition-colors ${isOpen ? 'border-brandBlue-200 bg-brandBlue-50/30' : 'border-slate-200 bg-white'}`} data-id="element-411" data-mp="1ntxexvldfh09" data-mpi={idx}>
                <button type="button" id={buttonId} aria-expanded={isOpen} aria-controls={panelId} onClick={() => setOpenIdx(isOpen ? null : idx)} className="w-full flex items-center justify-between p-6 text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-brandBlue-500 rounded-lg" data-id="element-412" data-mp="1xkjr1ftvppe7">
                  <span className="text-lg font-bold text-navy-900 pr-8" dangerouslySetInnerHTML={{
                __html: item.question
              }} data-id="element-413" data-mp="3w1khfgvwqvhz" />
                  <ChevronDown className={`w-6 h-6 flex-shrink-0 transition-transform duration-300 ${isOpen ? 'rotate-180 text-brandBlue-600' : 'text-slate-400'}`} aria-hidden="true" data-id="element-414" data-mp="9ovem7wbdw2x" />
                </button>
                <div id={panelId} role="region" aria-labelledby={buttonId} className={`grid transition-[grid-template-rows] duration-300 ease-out ${isOpen ? 'grid-rows-[1fr]' : 'grid-rows-[0fr]'}`} data-id="element-415" data-mp="3i2ukq2d02xu5">
                  <div className="overflow-hidden" data-id="element-416" data-mp="11cvsrhypd80p">
                    <div className="px-6 pb-6 text-slate-600 text-lg leading-relaxed" dangerouslySetInnerHTML={{
                  __html: item.answer
                }} data-id="element-417" data-mp="16crvzezksvf7" />
                  </div>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}